import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import {
    loadSourcingModal,
    ORIGIN_HOLD,
    ORIGIN_SOLD,
} from 'dibs-buyer-layout/src/utils/tradeOnboardingHelper';

// styles
import styles from './PdpSharedButtons.scss';

// helpers
import get from 'lodash.get';

export class PdpSharedRequestSourcingButton extends React.Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
    }

    openModal() {
        const email = get(this.props.user, 'profile.email');
        const item = this.props.item;
        const isSold = get(item, 'isSold');
        const isOnHold = get(item, 'isOnHold');
        const itemReferenceNumber = get(item, 'dibsReference');
        let requestOrigin = '';

        if (isSold) {
            requestOrigin = ORIGIN_SOLD;
        } else if (isOnHold) {
            requestOrigin = ORIGIN_HOLD;
        }

        loadSourcingModal({
            buyerEmail: email,
            requestOrigin,
            itemReferenceNumber,
            trackingLabel: 'cta - pdp - sidebar',
        });
    }

    render() {
        return (
            <div>
                <Button
                    className={`${styles.button} ${styles.fullWidth}`}
                    dataTn="item-actions-request-sourcing"
                    onClick={this.openModal}
                >
                    <FormattedMessage
                        id="PdpSharedRequestSourcingButton.requestSourcingCta"
                        defaultMessage="Request Sourcing Help"
                    />
                </Button>
            </div>
        );
    }
}

PdpSharedRequestSourcingButton.propTypes = {
    item: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedRequestSourcingButton, {
    user: graphql`
        fragment PdpSharedRequestSourcingButton_user on User {
            profile {
                email
            }
        }
    `,
    item: graphql`
        fragment PdpSharedRequestSourcingButton_item on Item {
            isSold
            isOnHold
            dibsReference
        }
    `,
});
